export const CoinInfo = {
  DAI: {
    description:
      'Stablecoin descentralizada creada por la MakerFoundation backeada en USDC y ETH y USDT.',
    url: 'https://makerdao.com/en/',
    detailUrl: 'makerdao.com/en',
    tags: [],
    creator: 'MakerDAO',
    nameSearchApi: 'multi-collateral-dai',
    category: 'Estable',
    visible: true,
  },
  DAICOMM: {
    description:
      'Dai es una stablecoin que tiene como objetivo mantener su valor lo más cercano posible al dólar estadounidense en la blockchain de Ethereum. Está respaldado por una combinación de activos y otras criptomonedas que se depositan en bóvedas de contratos inteligentes cada vez que se extrae un nuevo DAI.',
    url: 'https://makerdao.com/en/',
    tags: [],
  },
  USDC: {
    description:
      'Stablecoin centrealizada creada por Coinbase. Es reconocida dado que muchos bancos y fondos importantes de EEUU la utilizan y su creador está fuertemente regulado.',
    url: 'https://www.centre.io/usdc',
    detailUrl: 'centre.io/usdc',
    tags: [],
    creator: 'Circle',
    nameSearchApi: 'usd-coin',
    category: 'Estable',
    visible: true,
  },
  USDCCOMM: {
    description:
      'USD Coin es una stablecoin que está vinculada al dólar estadounidense en una relación de 1:1. Todas las unidades de esta criptomoneda en circulación están respaldadas por un dólar que se mantienen en reserva, en una combinación de efectivo y bonos del Tesoro de Estados Unidos a corto plazo.',
    url: 'https://www.centre.io/usdc',
    tags: [],
  },
  USDT: {
    description:
      'Stablecoin centralizada, tiene gran parte del mercado y basa su confianza en su posición dominante y siendo el par de intercambio principal en la mayoría de los Exchanges más grandes.',
    url: 'https://tether.to/',
    detailUrl: 'tether.to',
    tags: [],
    creator: 'Tether Limited',
    nameSearchApi: 'tether',
    category: 'Estable',
    visible: true,
  },
  USDTCOMM: {
    description:
      'Tether es una moneda digital con un valor destinado a ser un reflejo del dólar estadounidense. Lanzada en 2014, la idea detrás de Tether era crear una criptomoneda estable o "stablecoin" que se pueda usar como dólares digitales. Los Tethers están anclados o "atados" al precio del dólar estadounidense.',
    url: 'https://tether.to/',
    tags: [],
  },
  BUSD: {
    description:
      'Stablecoin centralizada creada para Binance por Paxos, lentamente siendo descontinuada por conflictos de intereses con el gobierno estadounidense.',
    url: 'https://www.binance.com/es/busd',
    detailUrl: 'binance.com/es/busd',
    tags: [],
    creator: 'Paxos',
    nameSearchApi: 'binance-usd',
    category: 'DeFi',
    visible: false,
  },
  BUSDCOMM: {
    description:
      'Binance USD es una moneda digital con un valor destinado a ser un reflejo del dólar estadounidense. Lanzada en 2019, la idea detrás de BUSD era crear una criptomoneda estable o "stablecoin" que se pueda usar como dólares digitales. Los BUSD están anclados o "atados" al precio del dólar estadounidense.',
    url: 'https://www.binance.com/es/busd',
    tags: [],
  },
  BNB: {
    description:
      'Moneda nativa a la Binance Smart Chain (Red blockchain manejada por binance). Se utiliza para llevar saldos y pagar contratos inteligentes dentro de la red.',
    url: 'https://www.binance.com/',
    detailUrl: 'binance.com',
    tags: [],
    creator: 'Binance',
    nameSearchApi: 'binance-coin',
    category: 'Blockchain',
    visible: true,
  },
  BTC: {
    description:
      'Moneda descentralizada nativa a la red de Bitcoin, se entrega como recompensa de minado y como "comisión" para realizar transferencias en la red.',
    url: 'https://bitcoin.org/',
    detailUrl: 'bitcoin.org',
    tags: [],
    creator: 'Satoshi Nakamoto',
    nameSearchApi: 'bitcoin',
    category: 'Blockchain',
    visible: true,
  },
  ETH: {
    description:
      'Moneda nativa a la red de Ethereum. Se utiliza para llevar saldos y pagar contratos inteligentes dentro de la red.',
    url: 'https://ethereum.org/',
    detailUrl: 'ethereum.org',
    tags: [],
    creator: 'Vitálik Buterin',
    nameSearchApi: 'ethereum',
    category: 'Blockchain',
    visible: true,
  },
  ADA: {
    description:
      'Cardano es una plataforma de blockchain de prueba de participación cuyo objetivo es permitir que los usuarios que sean "pioneros, innovadores y visionarios" traigan consigo un cambio global positivo a la red. Es considerada la primera blockchain cientifica del criptomundo',
    url: 'https://cardano.org/',
    tags: [],
  },
  CAKE: {
    description:
      'CAKE es una criptomoneda utiizada como moneda exclusiva para PancakeSwap, una aplicación de finanzas descentralizadas (DeFi) que permite a los usuarios intercambiar tokens, proporcionando liquidez a través de la agricultura y las comisiones por ganancias a cambio.',
    url: 'https://pancakeswap.finance/',
    tags: [],
  },
  MATIC: {
    description:
      'Moneda que se utiliza para pagar contratos y transferencias en la sidechain de Polygon. Trabaja como una extensión de Ethereum para hacerlo más barato y escalable.',
    url: 'https://polygon.technology/',
    detailUrl: 'polygon.technology',
    tags: [],
    creator: 'Matter Labs',
    nameSearchApi: 'polygon',
    category: 'Blockchain',
    visible: true,
  },
  POL: {
    description:
      'Moneda que se utiliza para pagar contratos y transferencias en la sidechain de Polygon. Trabaja como una extensión de Ethereum para hacerlo más barato y escalable.',
    url: 'https://polygon.technology/',
    detailUrl: 'polygon.technology',
    tags: [],
    creator: 'Matter Labs',
    nameSearchApi: 'polygon',
    category: 'Blockchain',
    visible: true,
  },
  AUST: {
    description:
      'Anchor Protocol es un protocolo de ahorro basado en la blockchain de Terra que proporciona rendimientos altos de monedas estables. TerraUSD (UST) es la moneda estable descentralizada y algorítmica de la blockchain de Terra. Es una moneda escalable y rentable cuyo valor está vinculado al dólar estadounidense.',
    url: 'https://anchorprotocol.com/dashboard/',
    tags: [],
  },
  DOGE: {
    description:
      'Dogecoin se basa en el popular meme de Internet "doge" y tiene un Shiba Inu en su logotipo. Los creadores de Dogecoin la vieron como una criptomoneda divertida y alegre que tendría un mayor atractivo más allá de la audiencia principal de Bitcoin.',
    url: 'https://dogecoin.com/',
    tags: [],
  },
  LUNA: {
    description: 'El token nativo de Terra, se usa para estabilizar el precio de sus stablecoins.',
    url: 'https://www.terra.money/',
    detailUrl: 'terra.money',
    tags: [],
    creator: 'Terra',
    nameSearchApi: 'luna-coin',
    category: 'Blockchain',
    visible: true,
  },
  SOL: {
    description:
      'Moneda nativa a la red de SOLANA, nace como una competencia barata a la red de Ethereum.',
    url: 'https://solana.com/',
    detailUrl: 'solana.com',
    tags: [],
    creator: 'Solana Foundation',
    nameSearchApi: 'solana',
    category: 'Blockchain',
    visible: true,
  },
  UST: {
    description:
      'TerraUSD es una stablecoin descentralizada y algorítmica de la blockchain Terra. Es una moneda escalable y rentable que está vinculada al valor del dólar estadounidense. TerraUSD promete a los usuarios un mayor nivel de escalabilidad, precisión de la tasa de interés y uso entre cadenas.',
    url: 'https://www.terra.money/',
    tags: [],
  },
  USTCOMM: {
    description:
      'TerraUSD es una stablecoin descentralizada y algorítmica de la blockchain Terra. Es una moneda escalable y rentable que está vinculada al valor del dólar estadounidense. TerraUSD promete a los usuarios un mayor nivel de escalabilidad, precisión de la tasa de interés y uso entre cadenas.',
    url: 'https://www.terra.money/',
    tags: [],
  },
  AXS: {
    description:
      'Axie Infinity es un juego de lucha y comercio basado en blockchain que pertenece y es operado parcialmente por sus jugadores. Inspirado en juegos populares como Pokémon y Tamagotchi, Axie Infinity permite a los jugadores recolectar, criar, luchar e intercambiar criaturas basadas en fichas conocidas como Axies.',
    url: 'https://axieinfinity.com/',
    detailUrl: 'axieinfinity.com',
    tags: [],
    creator: 'Sky Mavis',
    nameSearchApi: 'axie-infinity',
    category: 'Gaming',
    visible: true,
  },
  MANA: {
    description:
      'Decentraland se define como una plataforma de realidad virtual impulsada por la blockchain Ethereum que permite a los usuarios crear, experimentar y monetizar contenido y aplicaciones. En este mundo virtual, los usuarios compran parcelas de tierra que luego pueden navegar, construir y monetizar.',
    url: 'https://decentraland.org/',
    detailUrl: 'decentraland.org',
    tags: [],
    creator: 'Maxim Blagov y Witek Radomski',
    nameSearchApi: 'decentraland',
    category: 'Gaming',
    visible: true,
  },
  ENJ: {
    description:
      'Enjin Coin es un proyecto de Enjin, una empresa que proporciona un ecosistema de productos de juego interconectados basados en blockchain. La oferta insignia de Enjin es Enjin Network, una plataforma de juegos sociales a través de la cual los usuarios pueden crear sitios web y clanes, chatear y alojar tiendas de artículos virtuales.',
    url: 'https://enjin.io/',
    detailUrl: 'enjin.io',
    tags: [],
    creator: 'Meilich y Ordano',
    nameSearchApi: 'enjin-coin',
    category: 'Gaming',
    visible: true,
  },
  SAND: {
    description:
      'The Sandbox es un mundo virtual en el que puedes crear tu personajes, mejorarlos e interactuar con un amplio mundo virtual al puro estilo Minecraft. Pero que, al mismo tiempo, se apoya en la tecnología blockchain para crear una experiencia única mediante la utilización de tokens NFT y SAND, el token nativo de la plataforma, que te permite monetizar tu juego y obtener beneficios por ello.',
    url: 'https://www.sandbox.game/en/',
    detailUrl: 'sandbox.game/en/',
    tags: [],
    creator: 'Animoca Brands',
    nameSearchApi: 'the-sandbox',
    category: 'Metaverso',
    visible: true,
  },
  PSG: {
    description:
      'Paris Saint-Germain Fan Token es un token de fan de Socios.com. Los fan tokens les dan a los poseedores una participación en la gobernanza del club al permitirles influir en las decisiones, desbloquear recompensas VIP y acceder a promociones, juegos y reconocimientos especiales exclusivos.',
    url: 'https://fantoken.com/psg/',
    detailUrl: 'fantoken.com/psg/',
    tags: [],
    creator: 'socios.com',
    nameSearchApi: 'paris-saint-germain-fan-token',
    category: 'Fútbol',
    visible: true,
  },
  ATM: {
    description:
      'Atletico De Madrid Fan Token es un token de fan de Socios.com. Los fan tokens les dan a los poseedores una participación en la gobernanza del club al permitirles influir en las decisiones, desbloquear recompensas VIP y acceder a promociones, juegos y reconocimientos especiales exclusivos.',
    url: 'https://fantoken.com/atm/',
    detailUrl: 'fantoken.com/atm/',
    tags: [],
    creator: 'socios.com',
    category: 'Fútbol',
    visible: true,
  },
  BAR: {
    description:
      'FC Barcelona Fan Token es un token de fan de Socios.com. Los fan tokens les dan a los poseedores una participación en la gobernanza del club al permitirles influir en las decisiones, desbloquear recompensas VIP y acceder a promociones, juegos y reconocimientos especiales exclusivos.',
    url: 'https://fantoken.com/bar/',
    detailUrl: 'fantoken.com/bar/',
    tags: [],
    creator: 'socios.com',
    nameSearchApi: 'fc-barcelona-fan-token',
    category: 'Fútbol',
    visible: true,
  },
  CITY: {
    description:
      'Manchester City Fan Token es un token de fan de Socios.com. Los fan tokens les dan a los poseedores una participación en la gobernanza del club al permitirles influir en las decisiones, desbloquear recompensas VIP y acceder a promociones, juegos y reconocimientos especiales exclusivos.',
    url: 'https://www.socios.com/',
    detailUrl: 'socios.com',
    tags: [],
    creator: 'socios.com',
    category: 'Fútbol',
    visible: true,
  },
  LUNC: {
    description: 'El token nativo de Terra, se usa para estabilizar el precio de sus stablecoins.',
    url: 'https://www.terra.money/',
    detailUrl: 'terra.money',
    tags: [],
    creator: 'Terra',
    nameSearchApi: 'terra-luna',
    category: 'Blockchain',
    visible: true,
  },
  USTC: {
    description: 'Es una stablecoin descentralizada y algorítmica de la blockchain Terra.',
    url: 'https://www.terra.money/',
    detailUrl: 'terra.money',
    tags: [],
    creator: 'Terra',
    nameSearchApi: 'terrausd',
    category: 'DeFi',
    visible: true,
  },
  NUARS: {
    description: 'Nuars es un token, cuyo objetivo es mantener la paridad con el peso argentino.',
    url: 'https://num.finance/nuars/',
    detailUrl: 'num.finance/nuars',
    tags: [],
    creator: 'Num Finance',
    category: 'Estable',
    visible: true,
  },
};
